// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header__container-cc69c1 {
  position: absolute;
  display: flex;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 100%;
  height: 64px;
  background: linear-gradient(180deg, var(--addition-40_60) 0%, transparent);
  z-index: 1;
}

.Header__viewers-a6ff3c {
  min-width: unset;
  pointer-events: none;
  cursor: pointer;
}

.Header__live-f96e56 {
  background-color: var(--addition-160);
  border-radius: 8px;
  padding: 6px 7px;
  margin: 0 8px;
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  color: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/ParticipantView/Header/styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,0EAAA;EACA,UAAA;AACF;;AAEA;EACE,gBAAA;EACA,oBAAA;EACA,eAAA;AACF;;AAEA;EACE,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,4BAAA;EACA,8CAAA;EACA,yBAAA;AACF","sourcesContent":[".container {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n  box-sizing: border-box;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 64px;\n  background: linear-gradient(180deg, var(--addition-40_60) 0%, transparent);\n  z-index: 1;\n}\n\n.viewers {\n  min-width: unset;\n  pointer-events: none;\n  cursor: pointer;\n}\n\n.live {\n  background-color: var(--addition-160);\n  border-radius: 8px;\n  padding: 6px 7px;\n  margin: 0 8px;\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  color: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Header__container-cc69c1`,
	"viewers": `Header__viewers-a6ff3c`,
	"live": `Header__live-f96e56`
};
module.exports = ___CSS_LOADER_EXPORT___;
